module.exports = __webpack_public_path__ + "static/media/play_icon.e6930fd0.svg";